import type React from 'react';

import { Avatar } from '@change/ds-core-ui';

import type { PetitionContentUpdate } from 'src/app/pages/petitionDetails/shared/types';
import { useLoadImage } from 'src/app/shared/hooks/image';

type Props = Readonly<{
	update: PetitionContentUpdate;
}>;

const MAX_ATTEMPTS = 10;
const POLLING_TIME = 3 * 1000; // 3sec
const IMAGE_WIDTH = 40;

export const UpdateMedia: React.FC<Props> = ({ update }) => {
	const { photo } = update;

	const imageLoaded = useLoadImage(photo?.url, {
		maxAttempts: MAX_ATTEMPTS,
		pollingTime: POLLING_TIME,
		processing: photo?.processing,
	});

	if (!photo) {
		return <Avatar className="bg-green-600" size={IMAGE_WIDTH} initial="S" initialVariant="strong" alt="" />;
	}

	if (imageLoaded) {
		return <Avatar size={IMAGE_WIDTH} src={photo.url} alt="" />;
	}

	// TODO: Replace with DS Loader when available
	return <Avatar className="bg-green-600" size={IMAGE_WIDTH} initial="S" initialVariant="strong" alt="" />;
};
